import o, { useEffect as T, useRef as b } from "react";
import A from "classnames";
import { CSSTransition as h } from "react-transition-group";
import { ActionButtonsType as E } from "../../../../pages/landing/shared/actions.enum.js";
import { useWindowSize as d } from "../../../dom/hooks/useWindowSize.js";
import { OpacityAnimation as _ } from "../../../animations/OpacityAnimation/OpacityAnimation.js";
import { useAuth as N } from "../../../auth/hooks/useAuth.js";
import { UserMenu as D } from "../User/components/UserMenu/UserMenu.js";
import { NavbarProvider as R } from "./hooks/useNavbar/context.js";
import { useNavbar as S } from "./hooks/useNavbar/useNavbar.js";
import { RightSideMenu as O } from "./components/RightSideMenu.js";
import { LeftSideMenu as M } from "./components/LeftSideMenu.js";
import y from "./animations/collapse.module.scss.js";
import k from "./animations/opacity.module.scss.js";
import { useNavigation as w } from "../Navigation/hooks/useNavigation.js";
import { NavigationOutlet as L } from "../Navigation/NavigationOutlet.js";
import { NavigationProvider as W } from "../Navigation/provider.js";
import e from "./navbar.module.scss.js";
function P({
  children: f
}) {
  var B;
  const {
    menu: c,
    design: t,
    isDropdownMenuOpen: r,
    setIsDropdownMenuOpen: a,
    utmReferral: u
  } = S(), {
    navigate: v,
    isNavigationOpen: l,
    location: m
  } = w();
  T(() => {
    a(!1);
  }, [m]);
  const {
    customer: i
  } = N(), p = b(null), C = b(null), x = () => {
    v("/account", {
      overrideHistory: !0
    });
  }, {
    height: s
  } = d(), F = b(null), n = (s ?? 0) - (((B = F.current) == null ? void 0 : B.offsetHeight) ?? 0);
  return /* @__PURE__ */ o.createElement(o.Fragment, null, /* @__PURE__ */ o.createElement(
    "div",
    {
      "data-testid": "navbar-root",
      style: {
        backgroundColor: t.header.primaryColor,
        color: t.header.textColor
      },
      className: e.navbar
    },
    /* @__PURE__ */ o.createElement(
      "div",
      {
        ref: F,
        className: e.navbar__wrapper
      },
      /* @__PURE__ */ o.createElement(M, null),
      c && /* @__PURE__ */ o.createElement(O, null),
      /* @__PURE__ */ o.createElement(
        "div",
        {
          className: A({
            [e.navbar__userMenuWrapper]: !0,
            [e.navbar__routeMenuOpen]: l
          }),
          style: {
            display: l ? "block" : "none",
            "--borderColor": t.content.textColor ?? "",
            height: n
          }
        },
        /* @__PURE__ */ o.createElement(L, null)
      ),
      c && /* @__PURE__ */ o.createElement(o.Fragment, null, /* @__PURE__ */ o.createElement(
        h,
        {
          in: r && l && !!i,
          nodeRef: C,
          timeout: 200,
          classNames: {
            enter: k.opacityEnter,
            enterActive: k.opacityEnterActive,
            exit: k.opacityExit,
            exitActive: k.opacityExitActive
          },
          unmountOnExit: !0
        },
        /* @__PURE__ */ o.createElement(
          "div",
          {
            ref: C,
            style: { height: n },
            className: `${e.navbar__overlay} ${e.navbar__overlay__inner}`,
            onClick: () => a(!1)
          }
        )
      ), /* @__PURE__ */ o.createElement("div", { className: e.navbar__menuWrapper }, /* @__PURE__ */ o.createElement(
        h,
        {
          in: r,
          nodeRef: p,
          timeout: 600,
          classNames: {
            enter: y.collapseEnter,
            enterActive: y.collapseEnterActive,
            enterDone: y.collapseEnterDone,
            exit: y.collapseExit,
            exitActive: y.collapseExitActive
          },
          unmountOnExit: !0
        },
        /* @__PURE__ */ o.createElement(
          "div",
          {
            className: e.navbar__menuHeightWrapper,
            "data-testid": "user-menu",
            style: { height: n },
            ref: p
          },
          /* @__PURE__ */ o.createElement(
            D,
            {
              utmReferral: u,
              onAccountClick: () => x(),
              ...c.props,
              design: t
            }
          )
        )
      )))
    ),
    c && /* @__PURE__ */ o.createElement(
      _,
      {
        in: r || l && !!i
      },
      /* @__PURE__ */ o.createElement(
        "div",
        {
          style: { height: n },
          className: e.navbar__overlay,
          onClick: () => a(!1)
        }
      )
    )
  ), f);
}
function et(f) {
  var x;
  const {
    children: c,
    design: t,
    menu: r,
    profile: a,
    account: u,
    scope: v,
    utmReferral: l
  } = f;
  function m(s) {
    var F, n;
    return (n = (F = r == null ? void 0 : r.props.sections) == null ? void 0 : F.find((B) => B.type === s)) == null ? void 0 : n.text;
  }
  const i = {
    design: {
      textColor: (t == null ? void 0 : t.content.textColor) ?? "#000",
      headerText: (t == null ? void 0 : t.header.textColor) ?? "#FFF",
      headerBackground: (t == null ? void 0 : t.header.primaryColor) ?? "#242323",
      userCircleBackground: (t == null ? void 0 : t.content.userProfileBackground) ?? (t == null ? void 0 : t.accentColor) ?? "#EA565C"
    },
    buttons: u == null ? void 0 : u.actions
  }, p = {
    design: {
      ticketText: (t == null ? void 0 : t.content.textColor) ?? "#000",
      ticketBackground: (t == null ? void 0 : t.content.backgroundColor) ?? "#FFF",
      chipAccentText: (t == null ? void 0 : t.header.textColor) ?? "#FFF",
      chipAccentBackground: (t == null ? void 0 : t.accentColor) ?? "#EA565C",
      ticketLineColor: (t == null ? void 0 : t.content.borderColor) ?? "#DDD",
      ticketFollowText: (t == null ? void 0 : t.header.textColor) ?? "#FFF",
      ticketFollowBackground: (t == null ? void 0 : t.accentColor) ?? "#EA565C",
      cashbackTextColor: ((x = t == null ? void 0 : t.header) == null ? void 0 : x.textColor) ?? "#FFF",
      cashbackBackgroundColor: (t == null ? void 0 : t.header.primaryColor) ?? "#242323"
    }
  }, C = {
    design: {
      dotsBackground: (t == null ? void 0 : t.accentColor) ?? "#EA565C",
      bottomBackground: (t == null ? void 0 : t.content.backgroundColor) ?? "#FFF",
      modalDesign: {
        backgroundColor: (t == null ? void 0 : t.content.backgroundColor) ?? "#FFF",
        textColor: (t == null ? void 0 : t.content.textColor) ?? "#000",
        primaryButtonBackgroundColor: (t == null ? void 0 : t.content.primaryButtonBackground) ?? "#EA565C",
        primaryButtonTextColor: (t == null ? void 0 : t.content.primaryButtonText) ?? "#FFF",
        secondaryButtonBackgroundColor: t == null ? void 0 : t.content.secondaryButtonBackground,
        secondaryButtonTextColor: t == null ? void 0 : t.content.secondaryButtonText,
        borderColor: t == null ? void 0 : t.content.borderColor,
        fontFamily: t == null ? void 0 : t.font
      }
    }
  };
  return /* @__PURE__ */ o.createElement(
    W,
    {
      utmReferral: l,
      scope: v,
      navigationConfig: {
        common: {
          design: {
            background: (t == null ? void 0 : t.content.backgroundColor) ?? "#FFF",
            text: (t == null ? void 0 : t.content.textColor) ?? "#000",
            lines: (t == null ? void 0 : t.content.borderColor) ?? "#DDD"
          }
        },
        userAccount: i,
        userProfile: {
          account: i,
          profile: {
            design: {
              text: (t == null ? void 0 : t.content.textColor) ?? "#000",
              background: (t == null ? void 0 : t.content.backgroundColor) ?? "#FFF",
              primaryButtonText: (t == null ? void 0 : t.content.primaryButtonText) ?? "#FFF",
              primaryButtonBackground: (t == null ? void 0 : t.content.primaryButtonBackground) ?? "#EA565C",
              secondaryButtonText: (t == null ? void 0 : t.content.secondaryButtonText) ?? "#000",
              secondaryButtonBackground: (t == null ? void 0 : t.content.secondaryButtonBackground) ?? "#FFF",
              selectedTagText: (t == null ? void 0 : t.content.primaryButtonText) ?? "#FFF",
              selectedTagBackground: (t == null ? void 0 : t.content.primaryButtonBackground) ?? "#EA565C",
              unSelectedTagText: (t == null ? void 0 : t.content.secondaryButtonText) ?? "#FFF",
              unSelectedTagBackground: (t == null ? void 0 : t.content.secondaryButtonBackground) ?? "#FFF",
              lines: (t == null ? void 0 : t.content.borderColor) ?? "#DDD"
            },
            texts: a == null ? void 0 : a.texts
          }
        },
        orders: p,
        loyalty: {
          title: m(E.LOYALTY_LINK)
        },
        rewards: {
          ...C,
          title: m(E.REWARDS_LINK)
        },
        paymentMethods: {},
        myCashback: {
          viewOrder: p,
          design: {
            balanceChipBackgroundColor: (t == null ? void 0 : t.content.primaryButtonBackground) ?? "#e9dfb8",
            balanceChipTextColor: (t == null ? void 0 : t.content.primaryButtonText) ?? "#000"
          }
        },
        stampCards: {
          ...C,
          title: m(E.STAMP_CARDS)
        }
      }
    },
    /* @__PURE__ */ o.createElement(R, { ...f }, /* @__PURE__ */ o.createElement(P, null, c))
  );
}
export {
  et as Navbar,
  P as NavbarRoot
};
//# sourceMappingURL=Navbar.js.map
